/**
 * @file queue.ts
 * @description Сервис для работы с очередями задач в Task Manager. Предоставляет функциональность для получения списков задач из очередей, управления порядком выполнения и обработки очередных операций.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@src/types', '../actions.js']
 * @related-files ['C:\laragon\www\task-manager\src\api\actions.js', 'C:\laragon\www\task-manager\src\types\index.ts']
 */

import { TApiData } from '@src/types';
import { postRequest } from '../actions.js';
import { AxiosError, AxiosResponse } from 'axios';

export const QueueService = {
    /**
     * Получает список задач из указанной очереди
     * @param {string} name - Название очереди для получения списка задач
     * @param {TApiData} body - Дополнительные параметры тела запроса
     * @param {TApiData} params - Параметры запроса для фильтрации и пагинации
     * @returns {Promise} Промис с данными списка задач из очереди
     */
    getList: async (name: string, body?: TApiData, params?: TApiData): Promise<AxiosResponse | AxiosError> => {
        return await postRequest(`queue/${name}`, body, params);
    }
};
